import * as React from 'react';
import './index.scss';
import { StageDefault } from '@/context.ts';
import { fetch, RankItem, GetGuildDetailRsp } from '@/fetch.ts';
import DetailList from '@hooks/web/public/detailList.tsx';
import AnchorItem from '@hooks/web/public/anchorItem.tsx';
import Page from '@hooks/web/public/page.tsx';
import None from '@hooks/web/public/none.tsx';
const { useEffect, useState, useContext } = React;
interface Props {
  close: () => void,
  groupName: String,
  groupId: number,
  iStage: number,
  iArea: number,
}
const GroupDetail: React.FC<Props> = props => {
  const { iStage } = useContext(StageDefault);
  const [vContribution, VContribution] = useState<RankItem[]>([]);
  const [vContributionTotal, VContributionTotal] = useState<RankItem[]>([]);
  const [vRich, VRich] = useState<RankItem[]>([]);
  useEffect(() => {
    // fetch.getGuildDetail(
    //   {
    //     iStage: props.iStage,
    //     lCompanyId: props.groupId,
    //     iArea: props.iArea,
    //   },
    // )
    //   .then((rsp: GetGuildDetailRsp) => {
    //     console.log('公会详情', {
    //       iStage: props.iStage,
    //       lCompanyId: props.groupId,
    //       iArea: props.iArea,
    //     }, rsp);
        // VRich(rsp.vRich.value.slice(0, 25));
        // VContributionTotal(rsp.vContributionTotal.value.slice(0, 25));
        // VContribution(rsp.vContribution.value.slice(0, 25));
    //   })
    VRich(props.data.vRich.value.slice(0, 25));
    VContributionTotal(props.data.vContributionTotal.value.slice(0, 25));
    VContribution(props.data.vContribution.value.slice(0, 25));
  }, [props.groupId, iStage])
  return (
    <div
      className='web-groupDetail'
    >
      <div className='shadow' onClick={props.close}></div>
      <div className='detailContent'>
        <div className='title'><p>{props.groupName} 名人堂</p><i onClick={props.close} /></div>
        <ul className='detailrank'>
          {
            [['神豪榜', vRich], ['当前阶段贡献榜', vContribution], ['总贡献榜', vContributionTotal]].map((item: any, index: number) => (
              <DetailList key={index} list={item[1]} title={item[0]} index={index}/>
            ))
          }
        </ul>
      </div>
    </div>
  )
}

export default GroupDetail;